import { createContext, PropsWithChildren, useContext } from 'react';
import {
  ICustomerCommodityService,
  IFreightService,
  IPdfUploadService,
  IProductService,
  IUserMappingService,
  IWpsEventService,
} from 'shared/service';
import { AppConfig } from 'shared/types';

export interface ServiceContext {
  appConfig: AppConfig;
  productService: IProductService;
  customerCommodityService: ICustomerCommodityService;
  userMappingService: IUserMappingService;
  wpsEventService: IWpsEventService;
  pdfUploadService: IPdfUploadService;
  freightService: IFreightService;
}
type ServiceProviderProps = {
  context: ServiceContext;
};

const serviceContext = createContext<ServiceContext>({} as ServiceContext);

export function ProvideService({ children, context }: PropsWithChildren<ServiceProviderProps>) {
  return <serviceContext.Provider value={context}>{children}</serviceContext.Provider>;
}

export function useService() {
  return useContext(serviceContext);
}
